<template>
  <div class="d-flex align-items-center justify-content-center height-100vh">
    <div>
      <div class="image-wrapper">
        <b-img
          :src="sideImg"
          class="success-image mb-1"
        />
      </div>
      <div class="d-flex align-items-center justify-content-center">
        <h3 class="d-inline-block width-auto">
          Your Payment is Successfull
        </h3>
      </div>
      <h5 class="text-center">
        Thank you for your payment. An automated payment confirmation message will be sent to your mobile.
      </h5>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BImg,
  },
  data() {
    return {
      sideImg: require('@/assets/images/pages/Payment-Success.jpg'),
    }
  },
}
</script>

<style lang="scss" scoped>
.success-image {
  width: 100%;
  max-width: 600px;
  height: auto;
}
.image-wrapper {
  display: flex;
  justify-content: center;
}
</style>
